import { reactive } from 'vue';
import { ApiError } from '../api/client.js';

export interface ToastItem {
  id: number;
  text: string;
  kind: '' | 'ok' | 'bad' | 'warn';
}
export const toasts = reactive<ToastItem[]>([]);
let seq = 0;

/** 轻提示:底部居中,2.6 秒消失 */
export function toast(text: string, kind: ToastItem['kind'] = '', ms = 2600) {
  const id = ++seq;
  toasts.push({ id, text, kind });
  setTimeout(() => {
    const i = toasts.findIndex((t) => t.id === id);
    if (i >= 0) toasts.splice(i, 1);
  }, ms);
}

/** 接口错误统一提示:业务码附在后面便于反馈 */
export function toastError(e: unknown, fallback = '操作失败') {
  if (e instanceof ApiError) toast(`${e.message}(${e.code})`, 'bad', 3600);
  else toast(fallback, 'bad');
}
